import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardV2, PageHeader, Text } from '@feathr/components';

import * as shellStyles from '../Shell/PrototypeShell.css';

interface ISettingSection {
  description: string;
  name: string;
}

function SettingsPage(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const sections: ISettingSection[] = [
    {
      name: t('Account info'),
      description: t('Account name, address, time zone, and primary contact.'),
    },
    {
      name: t('Users & roles'),
      description: t('Add, remove, and assign roles to teammates.'),
    },
    {
      name: t('Billing'),
      description: t('License, services, invoices, and payment methods.'),
    },
    {
      name: t('Integrations'),
      description: t('Salesforce NPSP, Raiser’s Edge NXT, Stripe, Meta, Google.'),
    },
    {
      name: t('Compliance'),
      description: t('Data retention, GDPR/CCPA controls, audit log.'),
    },
  ];

  return (
    <>
      <PageHeader title={t('Settings')} />
      <Stack className={shellStyles.body} gap={theme.spacing['4']}>
        {sections.map((s) => (
          <CardV2 key={s.name} width={'full'}>
            <CardV2.Content title={s.name}>
              <Text variant={'smallRegular'}>{s.description}</Text>
            </CardV2.Content>
          </CardV2>
        ))}
      </Stack>
    </>
  );
}

export default SettingsPage;
